import { unicodeRegexp } from '@/utils/string/types'

export const getUnicodeChars = (text: string): string[] => {
  const unicodeChars: string[] = []
  const matches = [...text.matchAll(new RegExp(unicodeRegexp, 'giu'))]
  matches.forEach((match) => {
    if (match[0]?.trim().length) {
      unicodeChars.push(match[0]?.trim())
    }
  })

  return unicodeChars
}
